var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDownload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99922 1.4502C8.44105 1.4502 8.79922 1.80837 8.79922 2.2502V8.70391L11.214 6.53056C11.5425 6.23499 12.0483 6.26162 12.3439 6.59002C12.6394 6.91843 12.6128 7.42426 12.2844 7.71983L8.53439 11.0948C8.23015 11.3687 7.76829 11.3687 7.46405 11.0948L3.71405 7.71983C3.38564 7.42426 3.35902 6.91843 3.65458 6.59002C3.95015 6.26162 4.45598 6.23499 4.78439 6.53056L7.19922 8.70391V2.2502C7.19922 1.80837 7.55739 1.4502 7.99922 1.4502ZM1.99922 10.5752C2.44105 10.5752 2.79922 10.9334 2.79922 11.3752V12.5002C2.79922 12.8868 3.11262 13.2002 3.49922 13.2002H12.4992C12.8858 13.2002 13.1992 12.8868 13.1992 12.5002V11.3752C13.1992 10.9334 13.5574 10.5752 13.9992 10.5752C14.441 10.5752 14.7992 10.9334 14.7992 11.3752V12.5002C14.7992 13.7705 13.7695 14.8002 12.4992 14.8002H3.49922C2.22896 14.8002 1.19922 13.7705 1.19922 12.5002V11.3752C1.19922 10.9334 1.55739 10.5752 1.99922 10.5752Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.0c60807b5c89c7aaeecba86bb4522b94.svg";
export { ForwardRef as ReactComponent };